import * as React from "react";
import PaymentMakeFinishPage from "../pages/PaymentMakeFinish";
import { useDispatch } from "react-redux";
import { paymentActions } from "../store/payment";
import { useOnceCall } from "../custom-hooks/once-call";

const PaymentMakeFinishContainer = () => {
    const dispatch = useDispatch();
    useOnceCall(() => {
        dispatch(paymentActions.selectedPaymentSet(null));
    });
    return <PaymentMakeFinishPage />;
};

export default PaymentMakeFinishContainer;
